// extracted by mini-css-extract-plugin
module.exports = {"sfaPlayerStatCard":"sfaPlayerStatCard_sfaPlayerStatCard__20hNE","label":"sfaPlayerStatCard_label__L2FQ4","value":"sfaPlayerStatCard_value__d_fEZ"};